<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="normal"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText">
    <template #header>导入推广订单</template>
    <template #content>
      <div>
        <div>
          <gj-upload
              class="upload-btn"
              template-url="/operation/testOrder/exportTestOrderTemplate"
              container-type="promotionOrder"
              @uploadAfter="importPromoteOrder"
          >
            <template #tip>
              <span>只能上传xls/xlsx文件</span>
            </template>
          </gj-upload>
        </div>
        <gj-import-alert
            :rules="[
            '模板中的表头不可更改、位置不能调换，不能删除',
            '模板中表头文字为红色代表必填项，非红色则是选填项',
            '同一个订单编号如果在导入文件中存在多次，以第一条为准',
            '导入的订单编号如果已经标记为推广订单，本次导入时推广费用大于等于0，则直接用本次导入的费用更新系统现有记录',
            '导入的订单编号如果已经标记为推广订单，本次导入时备注字段不为空，则直接用本次导入的备注信息更新系统现有备注信息',
          ]">
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../minxins";
  import {importOrder} from "../../../../api/sale";

  export default {
    name: "promote-order-import",
    mixins: [modalMixIn, uploadMixin],
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      importPromoteOrder(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importOrder(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          }).complete(() => this.importHandleLoading = false)
      }
    }
  }
</script>

<style scoped>
  .upload-btn {
    margin-bottom: 16px;
  }
</style>
